var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "download-list-item", class: _vm.fileIsApprovedClass },
    [
      _c(
        "div",
        {
          staticClass:
            "download-list-item__icon download-list-item__icon--primary",
        },
        [_c("i", { staticClass: "fa fa-2x", class: _vm.getFileIcon })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "download-list-item__block" }, [
        _c("p", { staticClass: "download-list-item__label" }, [
          _vm._v("\n      " + _vm._s(_vm.file.file_name) + "\n      "),
          !_vm.fileIsApproved
            ? _c(
                "span",
                { staticClass: "download-list-item__label--unapproved" },
                [_vm._v(" - Unapproved")]
              )
            : _c(
                "span",
                { staticClass: "download-list-item__label--unapproved" },
                [
                  _vm._v(
                    " - " +
                      _vm._s(
                        _vm._f("date")(
                          _vm.fileLastUpdated,
                          _vm.$user.date_format_preference
                        )
                      )
                  ),
                ]
              ),
        ]),
        _vm._v(" "),
        _vm.fileIsApproved || _vm.userCanDownloadUnapprovedFile
          ? _c(
              "p",
              { staticClass: "download-list-item__link" },
              [
                _c("span", { on: { click: this.handleDownloadFileCallback } }, [
                  _c("i", { staticClass: "fa fa-cloud-download" }),
                  _vm._v(" Download File\n      "),
                ]),
                _vm._v(" "),
                this.$userIsAdmin && !_vm.fileIsApproved
                  ? _c(
                      "ladda-button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        attrs: { click: this.handleApproveFileCallback },
                      },
                      [_vm._v("\n        Approve File\n      ")]
                    )
                  : !_vm.fileIsApproved
                  ? _c(
                      "span",
                      { staticClass: "download-list-item__link--secondary" },
                      [
                        _vm._v(
                          "\n        - File is awaiting admin approval\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.canDeleteFile
        ? _c(
            "div",
            {
              staticClass:
                "download-list-item__icon download-list-item__icon--secondary",
            },
            [
              _c("i", {
                staticClass: "fa fa-times",
                class: _vm.deleting
                  ? "download-list-item__icon--disabled cursor-not-allowed"
                  : "cursor-pointer",
                on: { click: this.handleDeleteFileCallback },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }